module.exports = __webpack_public_path__ + "img/1.83c94761.png";